export var RibbonVariant;
(function (RibbonVariant) {
    RibbonVariant["NEW"] = "NEW";
    RibbonVariant["BETA"] = "BETA";
    RibbonVariant["LEGACY"] = "LEGACY";
})(RibbonVariant || (RibbonVariant = {}));
